/**
 * Digital purchase ticket shown after a successful checkout.
 */
import { ShieldCheck, DownloadSimple } from "@phosphor-icons/react";

export function DigitalTicket({ status, data, moneda, onClose }) {
  const folio = status.sale_id ? status.sale_id.slice(0, 8).toUpperCase() : "—";
  const amount = status.amount_total
    ? (status.amount_total / 100).toFixed(2)
    : Number(data.precio_venta || 0).toFixed(2);
  const currency = (status.currency || moneda || "MXN").toUpperCase();
  const fecha = new Date().toLocaleString("es-MX", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  const printTicket = () => window.print();
  return (
    <div
      className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4 print:bg-white print:p-0"
      data-testid="digital-ticket"
    >
      <div className="bg-white max-w-sm w-full p-6 border-2 border-black print:border-0 print:max-w-full">
        <div className="text-center border-b-2 border-black pb-3 mb-3">
          <div className="overline">Comprobante digital</div>
          <div className="h-display text-2xl font-black tracking-tighter mt-0.5">
            {data.negocio?.nombre || "VendeIA"}
          </div>
          <div className="text-[11px] text-muted2 font-mono mt-1">{fecha}</div>
        </div>

        <div className="text-center mb-4">
          <div className="w-12 h-12 mx-auto bg-[#E8F5E9] flex items-center justify-center mb-2 print:hidden">
            <ShieldCheck size={24} className="text-[#00C853]" weight="fill" />
          </div>
          <div className="text-sm font-semibold text-[#1B5E20]">PAGO CONFIRMADO</div>
        </div>

        <div className="space-y-1.5 text-sm mb-4">
          <div className="flex justify-between border-b border-dashed border-zinc-300 py-1">
            <span className="text-muted2">Folio</span>
            <span className="font-mono font-bold" data-testid="ticket-folio">{folio}</span>
          </div>
          <div className="flex justify-between border-b border-dashed border-zinc-300 py-1">
            <span className="text-muted2">Producto</span>
            <span className="font-medium text-right truncate ml-2">{data.nombre}</span>
          </div>
          <div className="flex justify-between border-b border-dashed border-zinc-300 py-1">
            <span className="text-muted2">Método</span>
            <span>Tarjeta · Stripe</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="font-bold">TOTAL</span>
            <span className="font-bold text-lg" data-testid="ticket-total">
              {currency} {amount}
            </span>
          </div>
        </div>

        <div className="border-t-2 border-dashed border-black pt-3 text-[10px] text-center text-muted2 leading-tight">
          Conserva este comprobante como evidencia del pago.
          <br />
          El vendedor te contactará para coordinar la entrega.
        </div>

        <div className="flex gap-2 mt-4 print:hidden">
          <button
            onClick={printTicket}
            className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 border border-zinc-300 text-sm font-medium hover:bg-zinc-50"
            data-testid="ticket-print"
          >
            <DownloadSimple size={14} weight="bold" /> Imprimir / PDF
          </button>
          <button
            onClick={onClose}
            className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 bg-klein text-white text-sm font-semibold hover:bg-klein-dark"
            data-testid="ticket-close"
          >
            Listo
          </button>
        </div>
      </div>
    </div>
  );
}
